/** Hero image/video slides, with independent slideshow and video playback. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 749px)');

  function init(root) {
    if (root.__iuropHeroInit) return;
    root.__iuropHeroInit = true;
    var cleanups = [];
    function listen(target, name, fn) {
      target.addEventListener(name, fn);
      cleanups.push(function () { target.removeEventListener(name, fn); });
    }
    var section = root.closest('.shopify-section');
    var controls = section && section.querySelector('[data-hero-test-controls]');
    var toggle = controls && controls.querySelector('[data-hero-mode-toggle]');
    if (toggle && root.querySelector('[data-hero-product]')) {
      controls.hidden = false;
      listen(toggle, 'click', function () {
        var productMode = root.getAttribute('data-hero-mode') !== 'product';
        root.setAttribute('data-hero-mode', productMode ? 'product' : 'editorial');
        toggle.setAttribute('aria-pressed', String(productMode));
        document.dispatchEvent(new CustomEvent('laganini:hero-mode-change'));
      });
    }
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var current = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var timer = null;
    var visible = true;
    var destroyed = false;
    var media = slides.map(function (slide) {
      var videos = Array.prototype.slice.call(slide.querySelectorAll('video.iurop-hero__video'));
      var button = slide.querySelector('[data-hero-video-toggle]');
      var item = { slide: slide, videos: videos, button: button, intent: null };
      function updateButton() {
        if (!button) return;
        var video = selectedVideo(item);
        var playing = video && !video.paused;
        button.setAttribute('aria-label', button.getAttribute(playing ? 'data-pause-label' : 'data-play-label'));
        button.querySelector('[data-video-play]').hidden = !!playing;
        button.querySelector('[data-video-pause]').hidden = !playing;
      }
      videos.forEach(function (video) {
        video.muted = true;
        listen(video, 'play', updateButton);
        listen(video, 'pause', updateButton);
      });
      if (button) {
        button.hidden = false;
        listen(button, 'click', function () {
          var video = selectedVideo(item);
          item.intent = video && !video.paused ? 'pause' : 'play';
          syncVideos();
        });
      }
      item.updateButton = updateButton;
      return item;
    });
    function selectedVideo(item) {
      return item.videos.length > 1 && mobile.matches ? item.videos[1] : item.videos[0];
    }
    function syncVideos() {
      media.forEach(function (item, index) {
        var selected = selectedVideo(item);
        var active = index === current && visible && !document.hidden && !destroyed;
        var autoplay = item.slide.getAttribute('data-video-autoplay') !== 'false';
        var play = active && (item.intent === 'play' || (item.intent !== 'pause' && autoplay && !reduced.matches));
        if (item.button) item.button.tabIndex = index === current ? 0 : -1;
        item.videos.forEach(function (video) {
          if (video === selected && play) {
            if (video.paused) {
              var pending = video.play();
              if (pending && pending.catch) pending.catch(item.updateButton);
            }
          } else {
            video.pause();
          }
        });
        item.updateButton();
      });
    }
    function show(index) {
      if (!slides.length) return;
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      syncVideos();
    }
    function start() {
      if (timer || reduced.matches || document.hidden || !visible || slides.length < 2 || root.getAttribute('data-autoplay') !== 'true') return;
      timer = window.setInterval(function () { show(current + 1); }, interval);
    }
    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }
    listen(root, 'mouseenter', stop);
    listen(root, 'mouseleave', start);
    listen(document, 'visibilitychange', function () {
      if (document.hidden) stop(); else start();
      syncVideos();
    });
    listen(reduced, 'change', function () {
      if (reduced.matches) stop(); else start();
      syncVideos();
    });
    listen(mobile, 'change', syncVideos);
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
        syncVideos();
      });
      observer.observe(root);
      cleanups.push(function () { observer.disconnect(); });
    }
    if (section) {
      listen(section, 'shopify:block:select', function (event) {
        var index = slides.findIndex(function (slide) { return slide === event.target || slide.contains(event.target); });
        if (index >= 0) { stop(); show(index); }
      });
      listen(section, 'shopify:block:deselect', start);
    }
    root.__iuropHeroDestroy = function () {
      destroyed = true;
      stop();
      syncVideos();
      cleanups.forEach(function (cleanup) { cleanup(); });
      root.__iuropHeroInit = false;
    };
    syncVideos();
    start();
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-hero]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-hero]').forEach(function (root) {
      if (root.__iuropHeroDestroy) root.__iuropHeroDestroy();
    });
  });
})();
